export default {
  tickers: {
  },
  radioValues: {
  },
};
